import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import KNCallToAction from 'components/KNCallToAction/KNCallToAction'
import { getStartPage } from 'context/authentication/User.helpers'
import { NavigationContextProvider } from 'context/navigation/NavigationContext'
import { analyticsPageView } from 'global/helpers/analytics'
import TopNavigation from 'modules/TopNavigation/TopNavigation'
import { memo, type ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

const ErrorNotFound = (): ReactElement => {
  const { t } = useTranslation()

  useEffect(() => {
    analyticsPageView('polestar/not-found')
  }, [])

  return (
    <NavigationContextProvider>
      <TopNavigation />
      <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
        <KNCallToAction
          image="/img/not-found.svg"
          lottie="/img/not-found-lottie.json"
          header={t('errors.NotFound.header')}
          content={t('errors.NotFound.content')}
        >
          <Button
            component={RouterLink}
            to="/help-and-info"
            variant="contained"
            color="primary"
          >
            {t('drawer_menu.help_and_info')}
          </Button>
          <Button
            component={RouterLink}
            to={getStartPage()}
            variant="contained"
            color="primary"
          >
            {t('errors.NotFound.action')}
          </Button>
        </KNCallToAction>
      </Stack>
    </NavigationContextProvider>
  )
}

export default memo(ErrorNotFound)
